import { render } from "./CrudSections.vue?vue&type=template&id=222fffa8"
import script from "./CrudSections.vue?vue&type=script&lang=js"
export * from "./CrudSections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__